import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Bot } from 'lucide-react'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { fetchBots, type AdminBotRow } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A5.01 — Botlar ro'yxati. GET /admin/bots (users.is_bot, backend `44666a8`).
 * Hozir bo'sh (bot yaratilmagan) — bot-platforma (A yo'li) bot qo'shgach to'ladi.
 */
export function BotsScreen() {
  const t = useT()

  const columns = useMemo<AdminColumn<AdminBotRow>[]>(
    () => [
      {
        key: 'username',
        header: t.col.username,
        type: 'text',
        minWidth: 160,
        render: (r) => (
          <Link to={`/bots/${r.id}`} className="text-accent hover:underline">
            {r.username ? `@${r.username}` : `#${r.id}`}
          </Link>
        ),
      },
      { key: 'first_name', header: t.col.name, type: 'text', minWidth: 160 },
      { key: 'is_official', header: t.bots.official, type: 'bool', width: 100 },
      { key: 'created_at', header: t.col.registered, type: 'date', width: 150 },
      { key: 'last_seen', header: t.users.lastSeen, type: 'date', width: 150 },
    ],
    [t],
  )

  const fetcher = useCallback(fetchBots, [])

  return (
    <>
      <PageHeader title={t.nav.bots} screenId="A5.01" verified />
      <DataTable<AdminBotRow>
        screenId="A5.01"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{
          icon: <Bot size={28} strokeWidth={1.5} />,
          title: t.bots.emptyTitle,
          description: t.bots.emptyDesc,
        }}
      />
    </>
  )
}
